<div class="company-home-container">
  <div class="side-bar">
    <sidebar-home [userType]="getUserType"></sidebar-home>
  </div>
  <div class="header">
    <header-home></header-home>
  </div>
  <div class="home">
    <div *ngIf="content === 'home' || (content === 'booking' && !coworkingId)" class="empty-space">
      <img [src]="getConfirmation">
      <p>{{ 'coworking-profile.on-construction' | translate}}</p>
    </div>
    <cowing-core-employees-home *ngIf="content === 'employees'"></cowing-core-employees-home>
    <cowing-core-spaces-home *ngIf="content === 'spaces'" [isCompany]="true"></cowing-core-spaces-home>
    <cowing-core-spendings-home *ngIf="content === 'spendings'" [companyId]="companyId"></cowing-core-spendings-home>
    <cowing-core-bookings-home *ngIf="content === 'booking' && coworkingId"></cowing-core-bookings-home>
  </div>
  <div class="footer">
    <cowing-footer></cowing-footer>
  </div>
</div>
